
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Vector","d":"M17.152 9.901l-4.922 4.907-4.921-4.907","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    